(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './kotlinx-io-kotlinx-io-core.js', './kotlinx-atomicfu.js', './kotlinx-io-kotlinx-io-bytestring.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./kotlinx-atomicfu.js'), require('./kotlinx-io-kotlinx-io-bytestring.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-bytestring'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-io-kotlinx-io-bytestring' was not found. Please, check whether 'kotlinx-io-kotlinx-io-bytestring' is loaded prior to 'ktor-ktor-io'.");
    }
    globalThis['ktor-ktor-io'] = factory(typeof globalThis['ktor-ktor-io'] === 'undefined' ? {} : globalThis['ktor-ktor-io'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['kotlinx-atomicfu'], globalThis['kotlinx-io-kotlinx-io-bytestring']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_org_jetbrains_kotlinx_kotlinx_io_bytestring) {
  'use strict';
  //region block: imports
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var toString = kotlin_kotlin.$_$.hp;
  var hashCode = kotlin_kotlin.$_$.bg;
  var equals = kotlin_kotlin.$_$.sf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var createFailure = kotlin_kotlin.$_$.ko;
  var Result = kotlin_kotlin.$_$.qn;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var toString_0 = kotlin_kotlin.$_$.cm;
  var newThrowable = kotlin_kotlin.$_$.xg;
  var stackTraceToString = kotlin_kotlin.$_$.yo;
  var VOID = kotlin_kotlin.$_$.d;
  var isInterface = kotlin_kotlin.$_$.rg;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var DisposableHandle = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b3;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var fromInt = kotlin_kotlin.$_$.pe;
  var compare = kotlin_kotlin.$_$.je;
  var numberToLong = kotlin_kotlin.$_$.we;
  var add = kotlin_kotlin.$_$.fe;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var returnIfSuspended = kotlin_kotlin.$_$.w3;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var Long = kotlin_kotlin.$_$.kn;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var Buffer = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.f;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.s4;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var CopyableThrowable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u2;
  var convertToInt = kotlin_kotlin.$_$.le;
  var toString_1 = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var IllegalStateException = kotlin_kotlin.$_$.in;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.x5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var IOException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.c;
  var decodeToString = kotlin_org_jetbrains_kotlinx_kotlinx_io_bytestring.$_$.d;
  var replace = kotlin_kotlin.$_$.xk;
  var indexOf = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.i;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var get_ONE = kotlin_kotlin.$_$.ee;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var EOFException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.a;
  var readString = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.n;
  var subtract = kotlin_kotlin.$_$.af;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var readByteString = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.l;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var startCoroutineCancellable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n2;
  var Continuation = kotlin_kotlin.$_$.rd;
  var KFunctionImpl = kotlin_kotlin.$_$.ni;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.fg;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p3;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c3;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l3;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var readString_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.m;
  var IOException = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.g;
  var IOException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.d;
  var Enum = kotlin_kotlin.$_$.en;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var listOf = kotlin_kotlin.$_$.ta;
  var IOException_init_$Create$_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.e;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.v4;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var readByteArray = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.j;
  var encodeToByteArray = kotlin_kotlin.$_$.sj;
  var writeString = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.o;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var replace_0 = kotlin_kotlin.$_$.yk;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var IOException_init_$Init$_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.b;
  var charSequenceSubSequence = kotlin_kotlin.$_$.mf;
  var readByteArray_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.k;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var trim = kotlin_kotlin.$_$.mm;
  var toByte = kotlin_kotlin.$_$.fh;
  var decodeToString_0 = kotlin_kotlin.$_$.pj;
  var setOf = kotlin_kotlin.$_$.sb;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var charSequenceGet = kotlin_kotlin.$_$.kf;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject(Empty, 'Empty');
  initMetadataForClass(Closed, 'Closed');
  function resume() {
    return this.lsa().y9(Companion_getInstance().isa_1);
  }
  function resume_0(throwable) {
    var tmp = this.lsa();
    var tmp_0;
    if (throwable == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(throwable));
      tmp_0 = new Result(tmp$ret$0);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp.y9(tmp1_elvis_lhs == null ? Companion_getInstance().isa_1 : tmp1_elvis_lhs.dr_1);
  }
  initMetadataForInterface(Task, 'Task');
  initMetadataForClass(Read, 'Read', VOID, VOID, [Task]);
  initMetadataForClass(Write, 'Write', VOID, VOID, [Task]);
  initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
  initMetadataForCoroutine($awaitContentCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($flushCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($flushAndCloseCOROUTINE$, CoroutineImpl);
  function awaitContent$default(min, $completion, $super) {
    min = min === VOID ? 1 : min;
    return $super === VOID ? this.rsc(min, $completion) : $super.rsc.call(this, min, $completion);
  }
  initMetadataForInterface(ByteReadChannel_1, 'ByteReadChannel', VOID, VOID, VOID, [1]);
  function get_autoFlush() {
    return false;
  }
  initMetadataForInterface(ByteWriteChannel, 'ByteWriteChannel', VOID, VOID, VOID, [0]);
  initMetadataForClass(ByteChannel, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel_1, ByteWriteChannel], [1, 0]);
  initMetadataForClass(ConcurrentIOException, 'ConcurrentIOException', VOID, IllegalStateException);
  initMetadataForCoroutine($findNextCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($advanceToNextPotentialMatchCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkFullMatchCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ByteChannelScanner, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(ByteReadChannel$Companion$Empty$1, VOID, VOID, VOID, [ByteReadChannel_1], [1]);
  initMetadataForCompanion(Companion_0);
  initMetadataForCoroutine($readRemainingCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readBufferCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readAvailableCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readRemainingCOROUTINE$_0, CoroutineImpl);
  initMetadataForCoroutine($toByteArrayCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($copyToCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($discardCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readLineCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($skipIfFoundCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readPacketCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($peekCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($internalReadLineToCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($internalReadLineTo$discardCrlfOrCrCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($flushIfNeededCOROUTINE$, CoroutineImpl);
  initMetadataForClass(WriterJob, 'WriterJob');
  initMetadataForClass(WriterScope, 'WriterScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(NO_CALLBACK$1, VOID, VOID, VOID, [Continuation]);
  initMetadataForFunctionReference(ByteWriteChannel$flushAndClose$ref_0, KFunctionImpl, VOID, [0]);
  initMetadataForLambda(writer$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(CloseToken, 'CloseToken');
  initMetadataForCoroutine($awaitContentCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(CountedByteReadChannel, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
  initMetadataForClass(ClosedByteChannelException, 'ClosedByteChannelException', ClosedByteChannelException, IOException);
  initMetadataForClass(ClosedReadChannelException, 'ClosedReadChannelException', ClosedReadChannelException, ClosedByteChannelException);
  initMetadataForClass(ClosedWriteChannelException, 'ClosedWriteChannelException', ClosedWriteChannelException, ClosedByteChannelException);
  initMetadataForClass(LineEnding, 'LineEnding', VOID, Enum);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(LineEndingMode, 'LineEndingMode');
  initMetadataForClass(SourceByteReadChannel, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
  initMetadataForClass(MalformedInputException, 'MalformedInputException', VOID, IOException);
  initMetadataForClass(TooLongLineException, 'TooLongLineException', VOID, MalformedInputException);
  function close() {
    this.s1d();
  }
  initMetadataForInterface(ObjectPool, 'ObjectPool', VOID, VOID, [AutoCloseable]);
  initMetadataForClass(DefaultPool, 'DefaultPool', VOID, VOID, [ObjectPool]);
  initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
  initMetadataForClass(NoPoolImpl, 'NoPoolImpl', VOID, VOID, [ObjectPool]);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(Charset, 'Charset');
  initMetadataForObject(Charsets, 'Charsets');
  initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
  initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
  initMetadataForClass(CharsetImpl, 'CharsetImpl', VOID, Charset);
  initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl', VOID, CharsetEncoder);
  initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl', VOID, CharsetDecoder);
  initMetadataForClass(toKtor$1);
  initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
  //endregion
  function Companion() {
    Companion_instance_0 = this;
    this.hsa_1 = new Closed(null);
    var tmp = this;
    // Inline function 'kotlin.Companion.success' call
    tmp.isa_1 = _Result___init__impl__xyqfz8(Unit_instance);
  }
  var Companion_instance_0;
  function Companion_getInstance() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function Empty() {
  }
  protoOf(Empty).toString = function () {
    return 'Empty';
  };
  protoOf(Empty).hashCode = function () {
    return -231472095;
  };
  protoOf(Empty).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Empty))
      return false;
    return true;
  };
  var Empty_instance;
  function Empty_getInstance() {
    return Empty_instance;
  }
  function Closed(cause) {
    this.jsa_1 = cause;
  }
  protoOf(Closed).toString = function () {
    return 'Closed(cause=' + toString(this.jsa_1) + ')';
  };
  protoOf(Closed).hashCode = function () {
    return this.jsa_1 == null ? 0 : hashCode(this.jsa_1);
  };
  protoOf(Closed).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Closed))
      return false;
    if (!equals(this.jsa_1, other.jsa_1))
      return false;
    return true;
  };
  function Task() {
  }
  function Read(continuation) {
    this.osa_1 = continuation;
    this.psa_1 = null;
    if (get_DEVELOPMENT_MODE()) {
      var tmp = this;
      // Inline function 'kotlin.also' call
      var this_0 = newThrowable('ReadTask 0x' + toString_0(hashCode(this.osa_1), 16));
      stackTraceToString(this_0);
      tmp.psa_1 = this_0;
    }
  }
  protoOf(Read).lsa = function () {
    return this.osa_1;
  };
  protoOf(Read).ksa = function () {
    return this.psa_1;
  };
  protoOf(Read).msa = function () {
    return 'read';
  };
  function Write(continuation) {
    this.qsa_1 = continuation;
    this.rsa_1 = null;
    if (get_DEVELOPMENT_MODE()) {
      var tmp = this;
      // Inline function 'kotlin.also' call
      var this_0 = newThrowable('WriteTask 0x' + toString_0(hashCode(this.qsa_1), 16));
      stackTraceToString(this_0);
      tmp.rsa_1 = this_0;
    }
  }
  protoOf(Write).lsa = function () {
    return this.qsa_1;
  };
  protoOf(Write).ksa = function () {
    return this.rsa_1;
  };
  protoOf(Write).msa = function () {
    return 'write';
  };
  function moveFlushToReadBuffer($this) {
    // Inline function 'io.ktor.utils.io.locks.synchronized' call
    $this.vsa_1;
    $this.tsa_1.os8($this.xsa_1);
    $this.usa_1 = 0;
    // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
    var current = $this.wsa_1.kotlinx$atomicfu$value;
    var tmp;
    if (current instanceof Write) {
      tmp = $this.wsa_1.atomicfu$compareAndSet(current, Empty_instance);
    } else {
      tmp = false;
    }
    if (tmp) {
      current.c3y();
    }
  }
  function closeSlot($this, cause) {
    var closeContinuation = !(cause == null) ? new Closed(cause) : Companion_getInstance().hsa_1;
    var continuation = $this.wsa_1.atomicfu$getAndSet(closeContinuation);
    if (isInterface(continuation, Task)) {
      continuation.nsa(cause);
    }
    var tmp0_safe_receiver = $this.asb_1.atomicfu$getAndSet(null);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(cause);
  }
  function sam$kotlinx_coroutines_DisposableHandle$0(function_0) {
    this.bsb_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).s1d = function () {
    return this.bsb_1();
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).q3 = function () {
    return this.bsb_1;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function ByteChannel$invokeOnClose$lambda() {
    return Unit_instance;
  }
  function ByteChannel$invokeOnClose$lambda_0() {
    return Unit_instance;
  }
  function ByteChannel$invokeOnClose$lambda_1(this$0, $handler) {
    return function () {
      this$0.asb_1.atomicfu$compareAndSet($handler, null);
      return Unit_instance;
    };
  }
  function $awaitContentCOROUTINE$(_this__u8e3s4, min, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ksb_1 = _this__u8e3s4;
    this.lsb_1 = min;
  }
  protoOf($awaitContentCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            rethrowCloseCauseIfNeeded_0(this.ksb_1);
            if (compare(this.ksb_1.xsa_1.n1(), fromInt(this.lsb_1)) >= 0)
              return true;
            this.msb_1 = this.ksb_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(compare(add(numberToLong(this.ksb_1.usa_1), this.ksb_1.xsa_1.n1()), fromInt(this.lsb_1)) < 0 && this.ksb_1.zsa_1.kotlinx$atomicfu$value == null)) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.v1e();
            var tmp0 = this.msb_1;
            var tmp2 = new Read(cancellable);
            l$ret$1: do {
              var previous = tmp0.wsa_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed)) {
                if (!tmp0.wsa_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.c3y();
                  break l$ret$1;
                }
              }
              if (previous instanceof Read) {
                previous.nsa(new ConcurrentIOException(tmp2.msa(), previous.ksa()));
              } else {
                if (isInterface(previous, Task)) {
                  previous.c3y();
                } else {
                  if (previous instanceof Closed) {
                    tmp2.nsa(previous.jsa_1);
                    break l$ret$1;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(compare(add(numberToLong(this.ksb_1.usa_1), this.ksb_1.xsa_1.n1()), fromInt(this.lsb_1)) < 0 && this.ksb_1.zsa_1.kotlinx$atomicfu$value == null)) {
                var current = tmp0.wsa_1.kotlinx$atomicfu$value;
                var tmp_0;
                if (current instanceof Read) {
                  tmp_0 = tmp0.wsa_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  current.c3y();
                }
              }
            }
             while (false);
            suspendResult = returnIfSuspended(cancellable.x1b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            if (compare(this.ksb_1.xsa_1.n1(), new Long(1048576, 0)) < 0) {
              moveFlushToReadBuffer(this.ksb_1);
            }

            return compare(this.ksb_1.xsa_1.n1(), fromInt(this.lsb_1)) >= 0;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $flushCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vsb_1 = _this__u8e3s4;
  }
  protoOf($flushCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            rethrowCloseCauseIfNeeded_0(this.vsb_1);
            this.vsb_1.xsb();
            if (this.vsb_1.ysb())
              return Unit_instance;
            this.wsb_1 = this.vsb_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(!this.vsb_1.ysb() && this.vsb_1.zsa_1.kotlinx$atomicfu$value == null)) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.v1e();
            var tmp0 = this.wsb_1;
            var tmp2 = new Write(cancellable);
            l$ret$1: do {
              var previous = tmp0.wsa_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed)) {
                if (!tmp0.wsa_1.atomicfu$compareAndSet(previous, tmp2)) {
                  tmp2.c3y();
                  break l$ret$1;
                }
              }
              if (previous instanceof Write) {
                previous.nsa(new ConcurrentIOException(tmp2.msa(), previous.ksa()));
              } else {
                if (isInterface(previous, Task)) {
                  previous.c3y();
                } else {
                  if (previous instanceof Closed) {
                    tmp2.nsa(previous.jsa_1);
                    break l$ret$1;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(!this.vsb_1.ysb() && this.vsb_1.zsa_1.kotlinx$atomicfu$value == null)) {
                var current = tmp0.wsa_1.kotlinx$atomicfu$value;
                var tmp_0;
                if (current instanceof Write) {
                  tmp_0 = tmp0.wsa_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  current.c3y();
                }
              }
            }
             while (false);
            suspendResult = returnIfSuspended(cancellable.x1b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $flushAndCloseCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hsc_1 = _this__u8e3s4;
  }
  protoOf($flushAndCloseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var this_0 = this.hsc_1;
            this.o9_1 = 2;
            this.jsc_1 = Companion_instance;
            this.n9_1 = 1;
            suspendResult = this_0.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            this.jsc_1;
            tmp_0.isc_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.o9_1 = 4;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var tmp_2 = this;
              tmp_2.isc_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 4;
            if (!this.hsc_1.zsa_1.atomicfu$compareAndSet(null, get_CLOSED()))
              return Unit_instance;
            closeSlot(this.hsc_1, null);
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function ByteChannel(autoFlush) {
    autoFlush = autoFlush === VOID ? false : autoFlush;
    this.ssa_1 = autoFlush;
    this.tsa_1 = new Buffer();
    this.usa_1 = 0;
    this.vsa_1 = new Object();
    this.wsa_1 = atomic$ref$1(Empty_instance);
    this.xsa_1 = new Buffer();
    this.ysa_1 = new Buffer();
    this.zsa_1 = atomic$ref$1(null);
    this.asb_1 = atomic$ref$1(null);
  }
  protoOf(ByteChannel).lsc = function () {
    return this.ssa_1;
  };
  protoOf(ByteChannel).ysb = function () {
    return this.usa_1 < 1048576;
  };
  protoOf(ByteChannel).msc = function () {
    var tmp0_safe_receiver = this.zsa_1.kotlinx$atomicfu$value;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'io.ktor.utils.io.Companion.throwOrNull' call
      // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
      var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
      var tmp;
      if (tmp0_subject == null) {
        tmp = null;
      } else {
        if (isInterface(tmp0_subject, CopyableThrowable)) {
          tmp = access$_get_origin__hdh1qz(tmp0_safe_receiver).n1h();
        } else {
          if (tmp0_subject instanceof CancellationException) {
            tmp = CancellationException_init_$Create$(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
          } else {
            var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
            tmp = new ClosedReadChannelException(p0);
          }
        }
      }
      var tmp0_safe_receiver_0 = tmp;
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        throw tmp0_safe_receiver_0;
      }
    }
    if (this.xsa_1.ms7()) {
      moveFlushToReadBuffer(this);
    }
    return this.xsa_1;
  };
  protoOf(ByteChannel).nsc = function () {
    if (this.osc()) {
      var tmp0_safe_receiver = this.zsa_1.kotlinx$atomicfu$value;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'io.ktor.utils.io.Companion.throwOrNull' call
        // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
        var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
        var tmp_0;
        if (tmp0_subject == null) {
          tmp_0 = null;
        } else {
          if (isInterface(tmp0_subject, CopyableThrowable)) {
            tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).n1h();
          } else {
            if (tmp0_subject instanceof CancellationException) {
              tmp_0 = CancellationException_init_$Create$(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
            } else {
              var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
              tmp_0 = new ClosedWriteChannelException(p0);
            }
          }
        }
        var tmp0_safe_receiver_0 = tmp_0;
        var tmp_1;
        if (tmp0_safe_receiver_0 == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          throw tmp0_safe_receiver_0;
        }
        tmp = tmp_1;
      }
      if (tmp == null)
        throw new ClosedWriteChannelException();
    }
    return this.ysa_1;
  };
  protoOf(ByteChannel).psc = function () {
    var tmp0_safe_receiver = this.zsa_1.kotlinx$atomicfu$value;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
      var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
      var tmp_0;
      if (tmp0_subject == null) {
        tmp_0 = null;
      } else {
        if (isInterface(tmp0_subject, CopyableThrowable)) {
          tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).n1h();
        } else {
          if (tmp0_subject instanceof CancellationException) {
            tmp_0 = CancellationException_init_$Create$(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
          } else {
            var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
            tmp_0 = new ClosedByteChannelException(p0);
          }
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ByteChannel).osc = function () {
    return !(this.zsa_1.kotlinx$atomicfu$value == null);
  };
  protoOf(ByteChannel).qsc = function () {
    return !(this.psc() == null) || (this.osc() && this.usa_1 === 0 && this.xsa_1.ms7());
  };
  protoOf(ByteChannel).rsc = function (min, $completion) {
    var tmp = new $awaitContentCOROUTINE$(this, min, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ByteChannel).ksc = function ($completion) {
    var tmp = new $flushCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ByteChannel).xsb = function () {
    if (this.ysa_1.ms7())
      return Unit_instance;
    // Inline function 'io.ktor.utils.io.locks.synchronized' call
    this.vsa_1;
    var count = convertToInt(this.ysa_1.n1());
    this.tsa_1.bs9(this.ysa_1);
    this.usa_1 = this.usa_1 + count | 0;
    // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
    var current = this.wsa_1.kotlinx$atomicfu$value;
    var tmp;
    if (current instanceof Read) {
      tmp = this.wsa_1.atomicfu$compareAndSet(current, Empty_instance);
    } else {
      tmp = false;
    }
    if (tmp) {
      current.c3y();
    }
  };
  protoOf(ByteChannel).j4 = function () {
    this.xsb();
    if (!this.zsa_1.atomicfu$compareAndSet(null, get_CLOSED()))
      return Unit_instance;
    closeSlot(this, null);
  };
  protoOf(ByteChannel).tsc = function ($completion) {
    var tmp = new $flushAndCloseCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ByteChannel).saa = function (cause) {
    if (!(this.zsa_1.kotlinx$atomicfu$value == null))
      return Unit_instance;
    var closedToken = new CloseToken(cause);
    this.zsa_1.atomicfu$compareAndSet(null, closedToken);
    // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
    var tmp0_subject = access$_get_origin__hdh1qz(closedToken);
    var tmp;
    if (tmp0_subject == null) {
      tmp = null;
    } else {
      if (isInterface(tmp0_subject, CopyableThrowable)) {
        tmp = access$_get_origin__hdh1qz(closedToken).n1h();
      } else {
        if (tmp0_subject instanceof CancellationException) {
          tmp = CancellationException_init_$Create$(access$_get_origin__hdh1qz(closedToken).message, access$_get_origin__hdh1qz(closedToken));
        } else {
          var p0 = access$_get_origin__hdh1qz(closedToken);
          tmp = new ClosedByteChannelException(p0);
        }
      }
    }
    var wrappedCause = tmp;
    closeSlot(this, wrappedCause);
  };
  protoOf(ByteChannel).usc = function (handler) {
    var existingCause = this.zsa_1.kotlinx$atomicfu$value;
    if (!(existingCause == null)) {
      // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
      var tmp0_subject = access$_get_origin__hdh1qz(existingCause);
      var tmp;
      if (tmp0_subject == null) {
        tmp = null;
      } else {
        if (isInterface(tmp0_subject, CopyableThrowable)) {
          tmp = access$_get_origin__hdh1qz(existingCause).n1h();
        } else {
          if (tmp0_subject instanceof CancellationException) {
            tmp = CancellationException_init_$Create$(access$_get_origin__hdh1qz(existingCause).message, access$_get_origin__hdh1qz(existingCause));
          } else {
            var p0 = access$_get_origin__hdh1qz(existingCause);
            tmp = new ClosedByteChannelException(p0);
          }
        }
      }
      handler(tmp);
      var tmp_0 = ByteChannel$invokeOnClose$lambda;
      return new sam$kotlinx_coroutines_DisposableHandle$0(tmp_0);
    }
    if (!this.asb_1.atomicfu$compareAndSet(null, handler)) {
      // Inline function 'kotlin.error' call
      var message = 'Only one invokeOnClose handler is supported per channel';
      throw IllegalStateException_init_$Create$(toString_1(message));
    }
    var cause = this.zsa_1.kotlinx$atomicfu$value;
    if (!(cause == null) && this.asb_1.atomicfu$compareAndSet(handler, null)) {
      // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
      var tmp0_subject_0 = access$_get_origin__hdh1qz(cause);
      var tmp_1;
      if (tmp0_subject_0 == null) {
        tmp_1 = null;
      } else {
        if (isInterface(tmp0_subject_0, CopyableThrowable)) {
          tmp_1 = access$_get_origin__hdh1qz(cause).n1h();
        } else {
          if (tmp0_subject_0 instanceof CancellationException) {
            tmp_1 = CancellationException_init_$Create$(access$_get_origin__hdh1qz(cause).message, access$_get_origin__hdh1qz(cause));
          } else {
            var p0_0 = access$_get_origin__hdh1qz(cause);
            tmp_1 = new ClosedByteChannelException(p0_0);
          }
        }
      }
      handler(tmp_1);
      var tmp_2 = ByteChannel$invokeOnClose$lambda_0;
      return new sam$kotlinx_coroutines_DisposableHandle$0(tmp_2);
    }
    var tmp_3 = ByteChannel$invokeOnClose$lambda_1(this, handler);
    return new sam$kotlinx_coroutines_DisposableHandle$0(tmp_3);
  };
  protoOf(ByteChannel).toString = function () {
    return 'ByteChannel[' + hashCode(this) + ']';
  };
  function ConcurrentIOException(taskName, cause) {
    cause = cause === VOID ? null : cause;
    IllegalStateException_init_$Init$('Concurrent ' + taskName + ' attempts', cause, this);
    captureStack(this, ConcurrentIOException);
  }
  function ByteReadChannel(content, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? content.length : length;
    // Inline function 'kotlin.also' call
    var this_0 = new Buffer();
    this_0.ts8(content, offset, offset + length | 0);
    var source = this_0;
    return ByteReadChannel_0(source);
  }
  function ByteReadChannel_0(source) {
    return new SourceByteReadChannel(source);
  }
  function buildPartialMatchTable($this) {
    var table = new Int32Array($this.wsc_1.n1());
    var j = 0;
    var inductionVariable = 1;
    var last = $this.wsc_1.n1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        while (j > 0 && !($this.wsc_1.l1(i) === $this.wsc_1.l1(j))) {
          j = table[j - 1 | 0];
        }
        if ($this.wsc_1.l1(i) === $this.wsc_1.l1(j)) {
          j = j + 1 | 0;
        }
        table[i] = j;
      }
       while (inductionVariable < last);
    return table;
  }
  function advanceToNextPotentialMatch($this, $completion) {
    var tmp = new $advanceToNextPotentialMatchCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkFullMatch($this, $completion) {
    var tmp = new $checkFullMatchCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkBounds($this, extra) {
    if (compare(add($this.csd_1, extra), $this.ysc_1) > 0) {
      throw IOException_init_$Create$('Limit of ' + $this.ysc_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.wsc_1) + '"'));
    }
  }
  function toSingleLineString($this, $receiver) {
    return replace(decodeToString($receiver), '\n', '\\n');
  }
  function $findNextCOROUTINE$(_this__u8e3s4, ignoreMissing, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hse_1 = _this__u8e3s4;
    this.ise_1 = ignoreMissing;
  }
  protoOf($findNextCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.hse_1.csd_1 = new Long(0, 0);
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.hse_1.zsc_1.ms7()) {
              this.jse_1 = true;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.hse_1.vsc_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.jse_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!this.jse_1) {
              this.n9_1 = 7;
              continue $sm;
            }

            this.n9_1 = 4;
            suspendResult = advanceToNextPotentialMatch(this.hse_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = checkFullMatch(this.hse_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (suspendResult) {
              return this.hse_1.csd_1;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 6:
            this.n9_1 = 1;
            continue $sm;
          case 7:
            if (!this.ise_1) {
              throw IOException_init_$Create$('Expected "' + toSingleLineString(this.hse_1, this.hse_1.wsc_1) + '" but encountered end of input');
            }

            this.hse_1.csd_1 = add(this.hse_1.csd_1, this.hse_1.bsd_1.os8(this.hse_1.xsc_1.nsc()));
            this.n9_1 = 8;
            suspendResult = this.hse_1.xsc_1.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            return this.hse_1.csd_1;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $advanceToNextPotentialMatchCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.msd_1 = _this__u8e3s4;
  }
  protoOf($advanceToNextPotentialMatchCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.msd_1.zsc_1.ms7()) {
              this.nsd_1 = true;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.msd_1.vsc_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.nsd_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!this.nsd_1) {
              this.n9_1 = 7;
              continue $sm;
            }

            var nextMatch = indexOf(this.msd_1.zsc_1, this.msd_1.wsc_1.l1(0));
            if (equalsLong(nextMatch, new Long(-1, -1))) {
              var tmp_0 = this.msd_1.zsc_1;
              checkBounds(this.msd_1, (tmp_0 instanceof Buffer ? tmp_0 : THROW_CCE()).n1());
              this.msd_1.csd_1 = add(this.msd_1.csd_1, this.msd_1.zsc_1.os8(this.msd_1.xsc_1.nsc()));
              this.n9_1 = 5;
              suspendResult = flushIfNeeded(this.msd_1.xsc_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              checkBounds(this.msd_1, nextMatch);
              var tmp_1 = this.msd_1;
              var tmp_2 = this.msd_1.csd_1;
              var tmp_3 = this.msd_1.xsc_1.nsc();
              tmp_1.csd_1 = add(tmp_2, this.msd_1.zsc_1.ls8(tmp_3 instanceof Buffer ? tmp_3 : THROW_CCE(), nextMatch));
              this.n9_1 = 4;
              suspendResult = flushIfNeeded(this.msd_1.xsc_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 4:
            return Unit_instance;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.n9_1 = 1;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $checkFullMatchCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wsd_1 = _this__u8e3s4;
  }
  protoOf($checkFullMatchCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.wsd_1.zsc_1.ms7()) {
              this.ysd_1 = true;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 2;
              suspendResult = this.wsd_1.vsc_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.ysd_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!this.ysd_1) {
              this.n9_1 = 7;
              continue $sm;
            }

            this.xsd_1 = this.wsd_1.zsc_1.ps7();
            if (this.wsd_1.dsd_1 > 0 && !(this.xsd_1 === this.wsd_1.wsc_1.l1(this.wsd_1.dsd_1))) {
              var oldMatchIndex = this.wsd_1.dsd_1;
              while (this.wsd_1.dsd_1 > 0 && !(this.xsd_1 === this.wsd_1.wsc_1.l1(this.wsd_1.dsd_1))) {
                this.wsd_1.dsd_1 = this.wsd_1.asd_1[this.wsd_1.dsd_1 - 1 | 0];
              }
              var retained = fromInt(oldMatchIndex - this.wsd_1.dsd_1 | 0);
              checkBounds(this.wsd_1, retained);
              var tmp_0 = this.wsd_1;
              var tmp_1 = this.wsd_1.csd_1;
              var tmp_2 = this.wsd_1.xsc_1.nsc();
              tmp_0.csd_1 = add(tmp_1, this.wsd_1.bsd_1.ls8(tmp_2 instanceof Buffer ? tmp_2 : THROW_CCE(), retained));
              if (this.wsd_1.dsd_1 === 0 && !(this.xsd_1 === this.wsd_1.wsc_1.l1(this.wsd_1.dsd_1))) {
                this.n9_1 = 6;
                suspendResult = writeByte(this.wsd_1.xsc_1, this.xsd_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.wsd_1.dsd_1 = this.wsd_1.dsd_1 + 1 | 0;
            if (this.wsd_1.dsd_1 === this.wsd_1.wsc_1.n1()) {
              return true;
            }

            this.wsd_1.bsd_1.cs9(this.xsd_1);
            this.n9_1 = 1;
            continue $sm;
          case 6:
            var _unary__edvuaz = this.wsd_1.csd_1;
            this.wsd_1.csd_1 = add(_unary__edvuaz, get_ONE());
            return false;
          case 7:
            return false;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ByteChannelScanner(channel, matchString, writeChannel, limit) {
    limit = limit === VOID ? new Long(-1, 2147483647) : limit;
    this.vsc_1 = channel;
    this.wsc_1 = matchString;
    this.xsc_1 = writeChannel;
    this.ysc_1 = limit;
    // Inline function 'kotlin.require' call
    if (!(this.wsc_1.n1() > 0)) {
      var message = 'Empty match string not permitted for scanning';
      throw IllegalArgumentException_init_$Create$(toString_1(message));
    }
    this.zsc_1 = this.vsc_1.msc();
    this.asd_1 = buildPartialMatchTable(this);
    this.bsd_1 = new Buffer();
    this.csd_1 = new Long(0, 0);
    this.dsd_1 = 0;
  }
  protoOf(ByteChannelScanner).kse = function (ignoreMissing, $completion) {
    var tmp = new $findNextCOROUTINE$(this, ignoreMissing, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function attachWriterJob(_this__u8e3s4, writerJob) {
    var tmp = writerJob.lse_1;
    var tmp0_safe_receiver = tmp instanceof ByteChannel ? tmp : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.usc(attachWriterJob$lambda(_this__u8e3s4));
    }
  }
  function attachWriterJob$lambda($this_attachWriterJob) {
    return function (cause) {
      var tmp;
      if (!(cause == null)) {
        $this_attachWriterJob.saa(cause);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ByteReadChannel$Companion$Empty$1() {
    this.nse_1 = null;
    this.ose_1 = new Buffer();
  }
  protoOf(ByteReadChannel$Companion$Empty$1).psc = function () {
    return this.nse_1;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).qsc = function () {
    return true;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).msc = function () {
    return this.ose_1;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).rsc = function (min, $completion) {
    return false;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).saa = function (cause) {
  };
  function Companion_0() {
    Companion_instance_1 = this;
    var tmp = this;
    tmp.pse_1 = new ByteReadChannel$Companion$Empty$1();
  }
  var Companion_instance_1;
  function Companion_getInstance_0() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function ByteReadChannel_1() {
  }
  function cancel_0(_this__u8e3s4) {
    _this__u8e3s4.saa(IOException_init_$Create$('Channel was cancelled'));
  }
  function readRemaining(_this__u8e3s4, max, $completion) {
    var tmp = new $readRemainingCOROUTINE$(_this__u8e3s4, max, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readBuffer(_this__u8e3s4, $completion) {
    var tmp = new $readBufferCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readAvailable(_this__u8e3s4, buffer, offset, length, $completion) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.length - offset | 0 : length;
    var tmp = new $readAvailableCOROUTINE$(_this__u8e3s4, buffer, offset, length, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readRemaining_0(_this__u8e3s4, $completion) {
    var tmp = new $readRemainingCOROUTINE$_0(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function toByteArray(_this__u8e3s4, $completion) {
    var tmp = new $toByteArrayCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function copyTo(_this__u8e3s4, channel, limit, $completion) {
    var tmp = new $copyToCOROUTINE$(_this__u8e3s4, channel, limit, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.psc();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
  }
  function discard(_this__u8e3s4, max, $completion) {
    max = max === VOID ? new Long(-1, 2147483647) : max;
    var tmp = new $discardCOROUTINE$(_this__u8e3s4, max, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readLine(_this__u8e3s4, lineEnding, $completion) {
    lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
    var tmp = new $readLineCOROUTINE$(_this__u8e3s4, lineEnding, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function skipIfFound(_this__u8e3s4, byteString, $completion) {
    var tmp = new $skipIfFoundCOROUTINE$(_this__u8e3s4, byteString, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readPacket(_this__u8e3s4, packet, $completion) {
    var tmp = new $readPacketCOROUTINE$(_this__u8e3s4, packet, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function readUntil(_this__u8e3s4, matchString, writeChannel, limit, ignoreMissing, $completion) {
    limit = limit === VOID ? new Long(-1, 2147483647) : limit;
    ignoreMissing = ignoreMissing === VOID ? false : ignoreMissing;
    return (new ByteChannelScanner(_this__u8e3s4, matchString, writeChannel, limit)).kse(ignoreMissing, $completion);
  }
  function readLineStrictTo(_this__u8e3s4, out, limit, lineEnding, $completion) {
    limit = limit === VOID ? new Long(-1, 2147483647) : limit;
    lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
    // Inline function 'kotlin.require' call
    if (!(compare(limit, new Long(0, 0)) >= 0)) {
      var message = 'Limit (' + limit.toString() + ') should be non-negative';
      throw IllegalArgumentException_init_$Create$(toString_1(message));
    }
    return internalReadLineTo(_this__u8e3s4, out, limit, lineEnding.equals(LineEnding_Lenient_getInstance()), true, $completion);
  }
  function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.psc();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
  }
  function get_availableForRead(_this__u8e3s4) {
    return convertToInt(_this__u8e3s4.msc().ls7().n1());
  }
  function readLineTo(_this__u8e3s4, out, lineEnding, $completion) {
    lineEnding = lineEnding === VOID ? LineEnding_Default_getInstance() : lineEnding;
    return internalReadLineTo(_this__u8e3s4, out, new Long(-1, 2147483647), lineEnding.equals(LineEnding_Lenient_getInstance()), false, $completion);
  }
  function peek(_this__u8e3s4, count, $completion) {
    var tmp = new $peekCOROUTINE$(_this__u8e3s4, count, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function internalReadLineTo(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion) {
    var tmp = new $internalReadLineToCOROUTINE$(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function throwEndOfStreamException(consumed) {
    throw EOFException_init_$Create$('Unexpected end of stream after reading ' + consumed.toString() + ' characters');
  }
  function throwTooLongLineException(limit) {
    throw new TooLongLineException('Line exceeds limit of ' + limit.toString() + ' characters');
  }
  function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.psc();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
  }
  function internalReadLineTo$transferString(readBuffer, $out, consumed, count) {
    if (compare(count, new Long(0, 0)) > 0) {
      var string = readString(readBuffer, count);
      $out.k1(string);
      var tmp0 = consumed._v;
      // Inline function 'kotlin.Long.plus' call
      var other = string.length;
      consumed._v = add(tmp0, fromInt(other));
    }
  }
  function internalReadLineTo$scanForSoleCr(_this__u8e3s4, $lenientLineEnding, lfIndex, limitLeft) {
    if (!$lenientLineEnding)
      return new Long(-1, -1);
    var tmp;
    if (equalsLong(lfIndex, new Long(-1, -1))) {
      // Inline function 'kotlin.Long.minus' call
      var this_0 = get_remaining(_this__u8e3s4);
      // Inline function 'kotlin.comparisons.minOf' call
      var b = subtract(this_0, fromInt(1));
      tmp = compare(limitLeft, b) <= 0 ? limitLeft : b;
    } else if (equalsLong(lfIndex, new Long(0, 0))) {
      tmp = new Long(0, 0);
    } else {
      // Inline function 'kotlin.Long.minus' call
      tmp = subtract(lfIndex, fromInt(1));
    }
    var endIndex = tmp;
    return indexOf(_this__u8e3s4, 13, VOID, endIndex);
  }
  function internalReadLineTo$discardCrlfOrCr(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion) {
    var tmp = new $internalReadLineTo$discardCrlfOrCrCOROUTINE$(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $readRemainingCOROUTINE$(_this__u8e3s4, max, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yse_1 = _this__u8e3s4;
    this.zse_1 = max;
  }
  protoOf($readRemainingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.asf_1 = BytePacketBuilder();
            this.bsf_1 = this.zse_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(!this.yse_1.qsc() && compare(this.bsf_1, new Long(0, 0)) > 0)) {
              this.n9_1 = 3;
              continue $sm;
            }

            if (compare(this.bsf_1, get_remaining(this.yse_1.msc())) >= 0) {
              this.bsf_1 = subtract(this.bsf_1, get_remaining(this.yse_1.msc()));
              this.yse_1.msc().os8(this.asf_1);
            } else {
              this.yse_1.msc().ns8(this.asf_1, this.bsf_1);
              this.bsf_1 = new Long(0, 0);
            }

            this.n9_1 = 2;
            suspendResult = this.yse_1.ssc(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return this.asf_1.ls7();
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readBufferCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ksf_1 = _this__u8e3s4;
  }
  protoOf($readBufferCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.lsf_1 = new Buffer();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.ksf_1.qsc()) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.lsf_1.bs9(this.ksf_1.msc());
            this.n9_1 = 2;
            suspendResult = this.ksf_1.ssc(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            var tmp0_safe_receiver = this.ksf_1.psc();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            return this.lsf_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readAvailableCOROUTINE$(_this__u8e3s4, buffer, offset, length, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.usf_1 = _this__u8e3s4;
    this.vsf_1 = buffer;
    this.wsf_1 = offset;
    this.xsf_1 = length;
  }
  protoOf($readAvailableCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.usf_1.qsc())
              return -1;
            if (this.usf_1.msc().ms7()) {
              this.n9_1 = 1;
              suspendResult = this.usf_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (this.usf_1.qsc())
              return -1;
            return readAvailable_0(this.usf_1.msc(), this.vsf_1, this.wsf_1, this.xsf_1);
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readRemainingCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gsg_1 = _this__u8e3s4;
  }
  protoOf($readRemainingCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.hsg_1 = BytePacketBuilder();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.gsg_1.qsc()) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.hsg_1.bs9(this.gsg_1.msc());
            this.n9_1 = 2;
            suspendResult = this.gsg_1.ssc(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            rethrowCloseCauseIfNeeded(this.gsg_1);
            return this.hsg_1.ls7();
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $toByteArrayCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qsg_1 = _this__u8e3s4;
  }
  protoOf($toByteArrayCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = readBuffer(this.qsg_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readBytes(ARGUMENT);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $copyToCOROUTINE$(_this__u8e3s4, channel, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zsg_1 = _this__u8e3s4;
    this.ash_1 = channel;
    this.bsh_1 = limit;
  }
  protoOf($copyToCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.csh_1 = this.bsh_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 8;
            this.o9_1 = 7;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!(!this.zsg_1.qsc() && compare(this.csh_1, new Long(0, 0)) > 0)) {
              this.n9_1 = 6;
              continue $sm;
            }

            if (this.zsg_1.msc().ms7()) {
              this.n9_1 = 3;
              suspendResult = this.zsg_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var tmp0 = this.csh_1;
            var b = get_remaining(this.zsg_1.msc());
            var count = compare(tmp0, b) <= 0 ? tmp0 : b;
            this.zsg_1.msc().ns8(this.ash_1.nsc(), count);
            this.csh_1 = subtract(this.csh_1, count);
            this.n9_1 = 5;
            suspendResult = this.ash_1.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 2;
            continue $sm;
          case 6:
            this.o9_1 = 12;
            this.n9_1 = 10;
            continue $sm;
          case 7:
            this.o9_1 = 8;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.q9_1;
              this.zsg_1.saa(cause);
              close_0(this.ash_1, cause);
              throw cause;
            } else {
              throw this.q9_1;
            }

          case 8:
            this.o9_1 = 12;
            this.dsh_1 = this.q9_1;
            this.n9_1 = 9;
            suspendResult = this.ash_1.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            throw this.dsh_1;
          case 10:
            this.o9_1 = 12;
            this.n9_1 = 11;
            suspendResult = this.ash_1.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            return subtract(this.bsh_1, this.csh_1);
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $discardCOROUTINE$(_this__u8e3s4, max, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.msh_1 = _this__u8e3s4;
    this.nsh_1 = max;
  }
  protoOf($discardCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.osh_1 = this.nsh_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(compare(this.osh_1, new Long(0, 0)) > 0 && !this.msh_1.qsc())) {
              this.n9_1 = 4;
              continue $sm;
            }

            if (get_availableForRead(this.msh_1) === 0) {
              this.n9_1 = 2;
              suspendResult = this.msh_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp0 = this.osh_1;
            var b = get_remaining(this.msh_1.msc());
            var count = compare(tmp0, b) <= 0 ? tmp0 : b;
            discard_0(this.msh_1.msc(), count);
            this.osh_1 = subtract(this.osh_1, count);
            this.n9_1 = 1;
            continue $sm;
          case 4:
            return subtract(this.nsh_1, this.osh_1);
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readLineCOROUTINE$(_this__u8e3s4, lineEnding, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xsh_1 = _this__u8e3s4;
    this.ysh_1 = lineEnding;
  }
  protoOf($readLineCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.asi_1 = StringBuilder_init_$Create$();
            this.n9_1 = 1;
            suspendResult = readLineTo(this.xsh_1, this.asi_1, this.ysh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            if (compare(ARGUMENT, new Long(0, 0)) >= 0) {
              this.zsh_1 = this.asi_1.toString();
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.zsh_1 = null;
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            return this.zsh_1;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $skipIfFoundCOROUTINE$(_this__u8e3s4, byteString, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jsi_1 = _this__u8e3s4;
    this.ksi_1 = byteString;
  }
  protoOf($skipIfFoundCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = peek(this.jsi_1, this.ksi_1.n1(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            if (equals(ARGUMENT, this.ksi_1)) {
              this.n9_1 = 3;
              suspendResult = discard(this.jsi_1, fromInt(this.ksi_1.n1()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            return false;
          case 3:
            return true;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readPacketCOROUTINE$(_this__u8e3s4, packet, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tsi_1 = _this__u8e3s4;
    this.usi_1 = packet;
  }
  protoOf($readPacketCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.vsi_1 = new Buffer();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(compare(this.vsi_1.n1(), fromInt(this.usi_1)) < 0)) {
              this.n9_1 = 5;
              continue $sm;
            }

            if (this.tsi_1.msc().ms7()) {
              this.n9_1 = 2;
              suspendResult = this.tsi_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (this.tsi_1.qsc()) {
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            if (compare(get_remaining(this.tsi_1.msc()), subtract(numberToLong(this.usi_1), this.vsi_1.n1())) > 0) {
              this.tsi_1.msc().ns8(this.vsi_1, subtract(numberToLong(this.usi_1), this.vsi_1.n1()));
            } else {
              this.tsi_1.msc().os8(this.vsi_1);
            }

            this.n9_1 = 1;
            continue $sm;
          case 5:
            if (compare(this.vsi_1.n1(), fromInt(this.usi_1)) < 0) {
              throw EOFException_init_$Create$('Not enough data available, required ' + this.usi_1 + ' bytes but only ' + this.vsi_1.n1().toString() + ' available');
            }

            return this.vsi_1;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $peekCOROUTINE$(_this__u8e3s4, count, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.esj_1 = _this__u8e3s4;
    this.fsj_1 = count;
  }
  protoOf($peekCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.esj_1.qsc())
              return null;
            this.n9_1 = 1;
            suspendResult = this.esj_1.rsc(this.fsj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (!suspendResult) {
              return null;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            return readByteString(this.esj_1.msc().v3n(), this.fsj_1);
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $internalReadLineToCOROUTINE$(_this__u8e3s4, out, limit, lenientLineEnding, throwOnIncompleteLine, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.osj_1 = _this__u8e3s4;
    this.psj_1 = out;
    this.qsj_1 = limit;
    this.rsj_1 = lenientLineEnding;
    this.ssj_1 = throwOnIncompleteLine;
  }
  protoOf($internalReadLineToCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 18;
            this.usj_1 = this.osj_1.msc();
            if (this.usj_1.ms7()) {
              this.n9_1 = 1;
              suspendResult = this.osj_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (this.osj_1.qsc())
              return new Long(-1, -1);
            this.tsj_1 = {_v: new Long(0, 0)};
            this.n9_1 = 3;
            continue $sm;
          case 3:
            if (!(compare(this.tsj_1._v, this.qsj_1) < 0 && !this.osj_1.qsc())) {
              this.n9_1 = 10;
              continue $sm;
            }

            var limitLeft = subtract(this.qsj_1, this.tsj_1._v);
            var lfIndex = indexOf(this.usj_1, 10, VOID, limitLeft);
            var crIndex = internalReadLineTo$scanForSoleCr(this.usj_1, this.rsj_1, lfIndex, limitLeft);
            if (compare(crIndex, new Long(0, 0)) >= 0) {
              internalReadLineTo$transferString(this.usj_1, this.psj_1, this.tsj_1, crIndex);
              discard_0(this.usj_1, new Long(1, 0));
              return this.tsj_1._v;
            }

            if (equalsLong(lfIndex, new Long(0, 0))) {
              discard_0(this.usj_1, new Long(1, 0));
              return this.tsj_1._v;
            }

            if (compare(lfIndex, new Long(0, 0)) > 0) {
              var tmp_0;
              var tmp_1 = this.usj_1.ls7();
              if (tmp_1.lx(subtract(lfIndex, fromInt(1))) === 13) {
                tmp_0 = new Long(1, 0);
              } else {
                tmp_0 = new Long(0, 0);
              }
              var isCrlf = tmp_0;
              internalReadLineTo$transferString(this.usj_1, this.psj_1, this.tsj_1, subtract(lfIndex, isCrlf));
              discard_0(this.usj_1, add(numberToLong(1), isCrlf));
              return this.tsj_1._v;
            }

            var b = get_remaining(this.usj_1);
            var count = compare(limitLeft, b) <= 0 ? limitLeft : b;
            var tmp_2 = this.usj_1.ls7();
            if (tmp_2.lx(subtract(count, fromInt(1))) === 13) {
              internalReadLineTo$transferString(this.usj_1, this.psj_1, this.tsj_1, subtract(count, fromInt(1)));
              this.n9_1 = 4;
              suspendResult = internalReadLineTo$discardCrlfOrCr(this.usj_1, this.osj_1, this.rsj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              internalReadLineTo$transferString(this.usj_1, this.psj_1, this.tsj_1, count);
              this.n9_1 = 6;
              continue $sm;
            }

          case 4:
            if (suspendResult) {
              return this.tsj_1._v;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            internalReadLineTo$transferString(this.usj_1, this.psj_1, this.tsj_1, new Long(1, 0));
            this.n9_1 = 6;
            continue $sm;
          case 6:
            if (compare(this.tsj_1._v, this.qsj_1) < 0 && equalsLong(get_remaining(this.usj_1), new Long(0, 0))) {
              this.n9_1 = 7;
              suspendResult = this.osj_1.ssc(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.wsj_1 = false;
              this.n9_1 = 8;
              continue $sm;
            }

          case 7:
            this.wsj_1 = !suspendResult;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            if (this.wsj_1) {
              this.n9_1 = 10;
              continue $sm;
            } else {
              this.n9_1 = 9;
              continue $sm;
            }

          case 9:
            this.n9_1 = 3;
            continue $sm;
          case 10:
            if (equalsLong(this.tsj_1._v, new Long(0, 0)) && this.osj_1.qsc())
              return new Long(-1, -1);
            if (!(compare(this.tsj_1._v, this.qsj_1) <= 0)) {
              var message = 'Consumed bytes exceed the limit: ' + this.tsj_1._v.toString() + ' > ' + this.qsj_1.toString() + ". It's an implementation bug, please report it.";
              throw IllegalStateException_init_$Create$(toString_1(message));
            }

            if (equalsLong(this.tsj_1._v, this.qsj_1)) {
              if (equalsLong(this.qsj_1, new Long(-1, 2147483647)))
                throw new TooLongLineException('Max line length exceeded');
              if (equalsLong(get_remaining(this.usj_1), new Long(0, 0))) {
                this.n9_1 = 12;
                suspendResult = this.osj_1.ssc(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.vsj_1 = false;
                this.n9_1 = 13;
                continue $sm;
              }
            } else {
              this.n9_1 = 11;
              continue $sm;
            }

          case 11:
            if (this.ssj_1) {
              throwEndOfStreamException(this.tsj_1._v);
            }

            return this.tsj_1._v;
          case 12:
            this.vsj_1 = !suspendResult;
            this.n9_1 = 13;
            continue $sm;
          case 13:
            if (this.vsj_1) {
              throwEndOfStreamException(this.tsj_1._v);
            } else {
              this.n9_1 = 14;
              continue $sm;
            }

            break;
          case 14:
            var tmp0_subject = this.usj_1.ls7().lx(new Long(0, 0));
            if (tmp0_subject === 10) {
              discard_0(this.usj_1, new Long(1, 0));
              return this.tsj_1._v;
            } else {
              if (tmp0_subject === 13) {
                this.n9_1 = 15;
                suspendResult = internalReadLineTo$discardCrlfOrCr(this.usj_1, this.osj_1, this.rsj_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 17;
                continue $sm;
              }
            }

          case 15:
            if (suspendResult) {
              return this.tsj_1._v;
            } else {
              this.n9_1 = 16;
              continue $sm;
            }

          case 16:
            this.n9_1 = 17;
            continue $sm;
          case 17:
            throwTooLongLineException(this.qsj_1);
            break;
          case 18:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 18) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $internalReadLineTo$discardCrlfOrCrCOROUTINE$(_this__u8e3s4, $this_internalReadLineTo, $lenientLineEnding, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fsk_1 = _this__u8e3s4;
    this.gsk_1 = $this_internalReadLineTo;
    this.hsk_1 = $lenientLineEnding;
  }
  protoOf($internalReadLineTo$discardCrlfOrCrCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            if (compare(get_remaining(this.fsk_1), new Long(2, 0)) >= 0) {
              this.jsk_1 = true;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = this.gsk_1.rsc(2, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.jsk_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (this.jsk_1) {
              this.isk_1 = this.fsk_1.ls7().lx(new Long(1, 0)) === 10;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.isk_1 = false;
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            if (this.isk_1) {
              discard_0(this.fsk_1, new Long(2, 0));
              return true;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            if (this.hsk_1) {
              discard_0(this.fsk_1, new Long(1, 0));
              return true;
            }

            return false;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ByteWriteChannel() {
  }
  function flushIfNeeded(_this__u8e3s4, $completion) {
    var tmp = new $flushIfNeededCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $flushIfNeededCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ssk_1 = _this__u8e3s4;
  }
  protoOf($flushIfNeededCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            rethrowCloseCauseIfNeeded_1(this.ssk_1);
            if (this.ssk_1.lsc() || get_size(this.ssk_1.nsc()) >= 1048576) {
              this.n9_1 = 1;
              suspendResult = this.ssk_1.ksc(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ByteWriteChannel$flushAndClose$ref(p0) {
    var i = new ByteWriteChannel$flushAndClose$ref_0(p0);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0, 1, 492, 'flushAndClose', [p0]);
  }
  function get_NO_CALLBACK() {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    return NO_CALLBACK;
  }
  var NO_CALLBACK;
  function writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? value.length : endIndex;
    _this__u8e3s4.nsc().ts8(value, startIndex, endIndex);
    return flushIfNeeded(_this__u8e3s4, $completion);
  }
  function WriterJob(channel, job) {
    this.lse_1 = channel;
    this.mse_1 = job;
  }
  protoOf(WriterJob).b1g = function () {
    return this.mse_1;
  };
  function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    autoFlush = autoFlush === VOID ? false : autoFlush;
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    return writer_0(_this__u8e3s4, coroutineContext, new ByteChannel(), block);
  }
  function WriterScope(channel, coroutineContext) {
    this.xsk_1 = channel;
    this.ysk_1 = coroutineContext;
  }
  protoOf(WriterScope).q19 = function () {
    return this.ysk_1;
  };
  function invokeOnCompletion(_this__u8e3s4, block) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    return _this__u8e3s4.b1g().t1a(block);
  }
  function close_0(_this__u8e3s4, cause) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    if (cause == null) {
      fireAndForget(ByteWriteChannel$flushAndClose$ref(_this__u8e3s4));
    } else {
      _this__u8e3s4.saa(cause);
    }
  }
  function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    // Inline function 'kotlin.apply' call
    var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda_0(block, channel, null));
    this_0.t1a(writer$lambda(channel));
    var job = this_0;
    return new WriterJob(channel, job);
  }
  function fireAndForget(_this__u8e3s4) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
  }
  function writeByte(_this__u8e3s4, value, $completion) {
    _this__u8e3s4.nsc().cs9(value);
    return flushIfNeeded(_this__u8e3s4, $completion);
  }
  function NO_CALLBACK$1() {
    this.zsk_1 = EmptyCoroutineContext_getInstance();
  }
  protoOf(NO_CALLBACK$1).t9 = function () {
    return this.zsk_1;
  };
  protoOf(NO_CALLBACK$1).u9 = function (result) {
    return Unit_instance;
  };
  protoOf(NO_CALLBACK$1).y9 = function (result) {
    return this.u9(result);
  };
  function ByteWriteChannel$flushAndClose$ref_0(p0) {
    KFunctionImpl.call(this, 1, 1, 492);
    this.wsk_1 = p0;
  }
  protoOf(ByteWriteChannel$flushAndClose$ref_0).r2b = function ($completion) {
    return this.wsk_1.tsc($completion);
  };
  protoOf(ByteWriteChannel$flushAndClose$ref_0).ia = function ($completion) {
    return this.r2b($completion);
  };
  function writer$slambda($block, $channel, resultContinuation) {
    this.isl_1 = $block;
    this.jsl_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(writer$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(writer$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(writer$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            this.nsl_1 = Job(get_job(this.ksl_1.q19()));
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.n9_1 = 2;
            suspendResult = this.isl_1(new WriterScope(this.jsl_1, this.ksl_1.q19().xj(this.nsl_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.nsl_1.w1g();
            var tmp_0;
            if (get_job(this.ksl_1.q19()).n1a()) {
              this.jsl_1.saa(get_job(this.ksl_1.q19()).q1a());
              tmp_0 = Unit_instance;
            }

            this.o9_1 = 14;
            this.n9_1 = 9;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var cause = this.q9_1;
              cancel(this.nsl_1, 'Exception thrown while writing to channel', cause);
              this.jsl_1.saa(cause);
              this.o9_1 = 14;
              this.n9_1 = 9;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 14;
            this.osl_1 = this.q9_1;
            this.n9_1 = 5;
            suspendResult = this.nsl_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.ksl_1;
            this.o9_1 = 7;
            this.qsl_1 = Companion_instance;
            this.n9_1 = 6;
            suspendResult = this.jsl_1.tsc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_2 = this;
            this.qsl_1;
            tmp_2.psl_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.o9_1 = 14;
            this.n9_1 = 8;
            continue $sm;
          case 7:
            this.o9_1 = 14;
            var tmp_3 = this.q9_1;
            if (tmp_3 instanceof Error) {
              var e = this.q9_1;
              var tmp_4 = this;
              tmp_4.psl_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.n9_1 = 8;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            this.o9_1 = 14;
            throw this.osl_1;
          case 9:
            this.o9_1 = 14;
            this.n9_1 = 10;
            suspendResult = this.nsl_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            this.ksl_1;
            this.o9_1 = 12;
            this.msl_1 = Companion_instance;
            this.n9_1 = 11;
            suspendResult = this.jsl_1.tsc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            var tmp_5 = this;
            this.msl_1;
            tmp_5.lsl_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.o9_1 = 14;
            this.n9_1 = 13;
            continue $sm;
          case 12:
            this.o9_1 = 14;
            var tmp_6 = this.q9_1;
            if (tmp_6 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_7 = this;
              tmp_7.lsl_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.n9_1 = 13;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 13:
            this.o9_1 = 14;
            return Unit_instance;
          case 14:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 14) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(writer$slambda).q24 = function ($this$launch, completion) {
    var i = new writer$slambda(this.isl_1, this.jsl_1, completion);
    i.ksl_1 = $this$launch;
    return i;
  };
  function writer$slambda_0($block, $channel, resultContinuation) {
    var i = new writer$slambda($block, $channel, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function writer$lambda($channel) {
    return function (it) {
      var tmp;
      if (!(it == null) && !$channel.osc()) {
        $channel.saa(it);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
  function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
    if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
      properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
      NO_CALLBACK = new NO_CALLBACK$1();
    }
  }
  function get_CLOSED() {
    _init_properties_CloseToken_kt__9ucr41();
    return CLOSED;
  }
  var CLOSED;
  function Companion_1() {
  }
  var Companion_instance_2;
  function Companion_getInstance_1() {
    return Companion_instance_2;
  }
  function access$_get_origin__hdh1qz($this) {
    return $this.rsl_1;
  }
  function CloseToken(origin) {
    this.rsl_1 = origin;
  }
  var properties_initialized_CloseToken_kt_lgg8zn;
  function _init_properties_CloseToken_kt__9ucr41() {
    if (!properties_initialized_CloseToken_kt_lgg8zn) {
      properties_initialized_CloseToken_kt_lgg8zn = true;
      CLOSED = new CloseToken(null);
    }
  }
  function transferFromDelegate($this) {
    updateConsumed($this);
    var appended = $this.tsl_1.bs9($this.ssl_1.msc());
    $this.usl_1 = add($this.usl_1, appended);
  }
  function updateConsumed($this) {
    $this.vsl_1 = add($this.vsl_1, subtract($this.usl_1, $this.tsl_1.n1()));
    $this.usl_1 = $this.tsl_1.n1();
  }
  function $awaitContentCOROUTINE$_0(_this__u8e3s4, min, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.esm_1 = _this__u8e3s4;
    this.fsm_1 = min;
  }
  protoOf($awaitContentCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (compare(this.esm_1.msc().n1(), fromInt(this.fsm_1)) >= 0) {
              return true;
            }

            this.n9_1 = 1;
            suspendResult = this.esm_1.ssl_1.rsc(this.fsm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              transferFromDelegate(this.esm_1);
              return true;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            return false;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CountedByteReadChannel(delegate) {
    this.ssl_1 = delegate;
    this.tsl_1 = new Buffer();
    this.usl_1 = new Long(0, 0);
    this.vsl_1 = new Long(0, 0);
  }
  protoOf(CountedByteReadChannel).gsm = function () {
    updateConsumed(this);
    return this.vsl_1;
  };
  protoOf(CountedByteReadChannel).psc = function () {
    return this.ssl_1.psc();
  };
  protoOf(CountedByteReadChannel).qsc = function () {
    return this.tsl_1.ms7() && this.ssl_1.qsc();
  };
  protoOf(CountedByteReadChannel).msc = function () {
    transferFromDelegate(this);
    return this.tsl_1;
  };
  protoOf(CountedByteReadChannel).rsc = function (min, $completion) {
    var tmp = new $awaitContentCOROUTINE$_0(this, min, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CountedByteReadChannel).saa = function (cause) {
    this.ssl_1.saa(cause);
    this.tsl_1.j4();
  };
  function counted(_this__u8e3s4) {
    return new CountedByteReadChannel(_this__u8e3s4);
  }
  function readText(_this__u8e3s4) {
    return readString_0(_this__u8e3s4);
  }
  function ClosedByteChannelException(cause) {
    cause = cause === VOID ? null : cause;
    IOException_init_$Init$(cause == null ? null : cause.message, cause, this);
    captureStack(this, ClosedByteChannelException);
  }
  function ClosedReadChannelException(cause) {
    cause = cause === VOID ? null : cause;
    ClosedByteChannelException.call(this, cause);
    captureStack(this, ClosedReadChannelException);
  }
  function ClosedWriteChannelException(cause) {
    cause = cause === VOID ? null : cause;
    ClosedByteChannelException.call(this, cause);
    captureStack(this, ClosedWriteChannelException);
  }
  var LineEnding_Default_instance;
  var LineEnding_Lenient_instance;
  var LineEnding_entriesInitialized;
  function LineEnding_initEntries() {
    if (LineEnding_entriesInitialized)
      return Unit_instance;
    LineEnding_entriesInitialized = true;
    LineEnding_Default_instance = new LineEnding('Default', 0);
    LineEnding_Lenient_instance = new LineEnding('Lenient', 1);
  }
  function LineEnding(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LineEnding_Default_getInstance() {
    LineEnding_initEntries();
    return LineEnding_Default_instance;
  }
  function LineEnding_Lenient_getInstance() {
    LineEnding_initEntries();
    return LineEnding_Lenient_instance;
  }
  function _LineEndingMode___init__impl__jo5bul(mode) {
    return mode;
  }
  function _get_mode__dah3bc($this) {
    return $this;
  }
  function LineEndingMode__contains_impl_q5pr68($this, other) {
    return (_get_mode__dah3bc($this) | _get_mode__dah3bc(other)) === _get_mode__dah3bc($this);
  }
  function LineEndingMode__plus_impl_ttpz2j($this, other) {
    return _LineEndingMode___init__impl__jo5bul(_get_mode__dah3bc($this) | _get_mode__dah3bc(other));
  }
  function LineEndingMode__toString_impl_j4h76r($this) {
    var tmp;
    if ($this === Companion_getInstance_2().hsm_1) {
      tmp = 'CR';
    } else if ($this === Companion_getInstance_2().ism_1) {
      tmp = 'LF';
    } else if ($this === Companion_getInstance_2().jsm_1) {
      tmp = 'CRLF';
    } else {
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = Companion_getInstance_2().lsm_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var it = element.msm_1;
        if (LineEndingMode__contains_impl_q5pr68($this, it)) {
          destination.j1(element);
        }
      }
      tmp = toString_1(destination);
    }
    return tmp;
  }
  function Companion_2() {
    Companion_instance_3 = this;
    this.hsm_1 = _LineEndingMode___init__impl__jo5bul(1);
    this.ism_1 = _LineEndingMode___init__impl__jo5bul(2);
    this.jsm_1 = _LineEndingMode___init__impl__jo5bul(4);
    this.ksm_1 = _LineEndingMode___init__impl__jo5bul(7);
    this.lsm_1 = listOf([new LineEndingMode(this.hsm_1), new LineEndingMode(this.ism_1), new LineEndingMode(this.jsm_1)]);
  }
  var Companion_instance_3;
  function Companion_getInstance_2() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function LineEndingMode__hashCode_impl_2mopm4($this) {
    return $this;
  }
  function LineEndingMode__equals_impl_qyr4nk($this, other) {
    if (!(other instanceof LineEndingMode))
      return false;
    if (!($this === other.msm_1))
      return false;
    return true;
  }
  function LineEndingMode(mode) {
    Companion_getInstance_2();
    this.msm_1 = mode;
  }
  protoOf(LineEndingMode).toString = function () {
    return LineEndingMode__toString_impl_j4h76r(this.msm_1);
  };
  protoOf(LineEndingMode).hashCode = function () {
    return LineEndingMode__hashCode_impl_2mopm4(this.msm_1);
  };
  protoOf(LineEndingMode).equals = function (other) {
    return LineEndingMode__equals_impl_qyr4nk(this.msm_1, other);
  };
  function SourceByteReadChannel(source) {
    this.nsm_1 = source;
    this.osm_1 = null;
  }
  protoOf(SourceByteReadChannel).psc = function () {
    var tmp0_safe_receiver = this.osm_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'io.ktor.utils.io.Companion.wrapCause' call
      var tmp0_subject = access$_get_origin__hdh1qz(tmp0_safe_receiver);
      var tmp_0;
      if (tmp0_subject == null) {
        tmp_0 = null;
      } else {
        if (isInterface(tmp0_subject, CopyableThrowable)) {
          tmp_0 = access$_get_origin__hdh1qz(tmp0_safe_receiver).n1h();
        } else {
          if (tmp0_subject instanceof CancellationException) {
            tmp_0 = CancellationException_init_$Create$(access$_get_origin__hdh1qz(tmp0_safe_receiver).message, access$_get_origin__hdh1qz(tmp0_safe_receiver));
          } else {
            var p0 = access$_get_origin__hdh1qz(tmp0_safe_receiver);
            tmp_0 = new ClosedByteChannelException(p0);
          }
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(SourceByteReadChannel).qsc = function () {
    return this.nsm_1.ms7();
  };
  protoOf(SourceByteReadChannel).msc = function () {
    var tmp0_safe_receiver = this.psc();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
    return this.nsm_1.ls7();
  };
  protoOf(SourceByteReadChannel).rsc = function (min, $completion) {
    var tmp0_safe_receiver = this.psc();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
    return this.nsm_1.os7(fromInt(min));
  };
  protoOf(SourceByteReadChannel).saa = function (cause) {
    if (!(this.osm_1 == null))
      return Unit_instance;
    this.nsm_1.j4();
    var tmp = this;
    var tmp1_elvis_lhs = cause == null ? null : cause.message;
    tmp.osm_1 = new CloseToken(IOException_init_$Create$_0(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
  };
  function decode(_this__u8e3s4, input, max) {
    max = max === VOID ? 2147483647 : max;
    var tmp0 = fromInt(max);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = input.ls7().n1();
    var tmp$ret$0 = compare(tmp0, b) <= 0 ? tmp0 : b;
    // Inline function 'kotlin.text.buildString' call
    var capacity = convertToInt(tmp$ret$0);
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0(capacity);
    decode_0(_this__u8e3s4, input, this_0, max);
    return this_0.toString();
  }
  function encode(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
    return builder;
  }
  function TooLongLineException(message) {
    MalformedInputException.call(this, message);
    captureStack(this, TooLongLineException);
  }
  function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
    var start = fromIndex;
    if (start >= toIndex)
      return Unit_instance;
    $l$loop: while (true) {
      var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, destination);
      // Inline function 'kotlin.check' call
      if (!(rc >= 0)) {
        throw IllegalStateException_init_$Create$('Check failed.');
      }
      start = start + rc | 0;
      if (start >= toIndex)
        break $l$loop;
    }
  }
  function canRead(_this__u8e3s4) {
    return !_this__u8e3s4.ms7();
  }
  function readBytes(_this__u8e3s4, count) {
    count = count === VOID ? convertToInt(_this__u8e3s4.n1()) : count;
    return readByteArray(_this__u8e3s4, count);
  }
  function writeFully_0(_this__u8e3s4, buffer, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.length - offset | 0 : length;
    _this__u8e3s4.ts8(buffer, offset, offset + length | 0);
  }
  function BytePacketBuilder() {
    return new Buffer();
  }
  function build(_this__u8e3s4) {
    return _this__u8e3s4.ls7();
  }
  function get_size(_this__u8e3s4) {
    return convertToInt(_this__u8e3s4.ls7().n1());
  }
  var ByteReadPacketEmpty;
  function get_remaining(_this__u8e3s4) {
    _init_properties_ByteReadPacket_kt__28475y();
    return _this__u8e3s4.ls7().n1();
  }
  function takeWhile(_this__u8e3s4, block) {
    _init_properties_ByteReadPacket_kt__28475y();
    while (!_this__u8e3s4.ms7() && block(_this__u8e3s4.ls7())) {
    }
  }
  function discard_0(_this__u8e3s4, count) {
    count = count === VOID ? new Long(-1, 2147483647) : count;
    _init_properties_ByteReadPacket_kt__28475y();
    _this__u8e3s4.os7(count);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(_this__u8e3s4);
    var countToDiscard = compare(count, b) <= 0 ? count : b;
    _this__u8e3s4.ls7().is8(countToDiscard);
    return countToDiscard;
  }
  var properties_initialized_ByteReadPacket_kt_hw4st4;
  function _init_properties_ByteReadPacket_kt__28475y() {
    if (!properties_initialized_ByteReadPacket_kt_hw4st4) {
      properties_initialized_ByteReadPacket_kt_hw4st4 = true;
      ByteReadPacketEmpty = new Buffer();
    }
  }
  function readAvailable_0(_this__u8e3s4, buffer, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.length - offset | 0 : length;
    var result = _this__u8e3s4.js8(buffer, offset, offset + length | 0);
    return result === -1 ? 0 : result;
  }
  function readText_0(_this__u8e3s4, charset, max) {
    charset = charset === VOID ? Charsets_getInstance().psm_1 : charset;
    max = max === VOID ? 2147483647 : max;
    if (charset.equals(Charsets_getInstance().psm_1)) {
      if (max === 2147483647)
        return readString_0(_this__u8e3s4);
      var tmp0 = _this__u8e3s4.ls7().n1();
      // Inline function 'kotlin.math.min' call
      var b = fromInt(max);
      var count = compare(tmp0, b) <= 0 ? tmp0 : b;
      return readString(_this__u8e3s4, count);
    }
    return decode(charset.ssm(), _this__u8e3s4, max);
  }
  function toByteArray_0(_this__u8e3s4, charset) {
    charset = charset === VOID ? Charsets_getInstance().psm_1 : charset;
    if (charset.equals(Charsets_getInstance().psm_1))
      return encodeToByteArray(_this__u8e3s4, VOID, VOID, true);
    return encodeToByteArray_0(charset.tsm(), _this__u8e3s4, 0, _this__u8e3s4.length);
  }
  function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
    charset = charset === VOID ? Charsets_getInstance().psm_1 : charset;
    if (charset === Charsets_getInstance().psm_1) {
      return writeString(_this__u8e3s4, toString_1(text), fromIndex, toIndex);
    }
    encodeToImpl(charset.tsm(), _this__u8e3s4, text, fromIndex, toIndex);
  }
  function get_ByteArrayPool() {
    _init_properties_ByteArrayPool_kt__kfi3uj();
    return ByteArrayPool;
  }
  var ByteArrayPool;
  function ByteArrayPool$1() {
    DefaultPool.call(this, 128);
  }
  protoOf(ByteArrayPool$1).xsm = function () {
    return new Int8Array(4096);
  };
  var properties_initialized_ByteArrayPool_kt_td6pfh;
  function _init_properties_ByteArrayPool_kt__kfi3uj() {
    if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
      properties_initialized_ByteArrayPool_kt_td6pfh = true;
      ByteArrayPool = new ByteArrayPool$1();
    }
  }
  function ObjectPool() {
  }
  function NoPoolImpl() {
  }
  protoOf(NoPoolImpl).fsn = function (instance) {
    return Unit_instance;
  };
  protoOf(NoPoolImpl).s1d = function () {
    return Unit_instance;
  };
  function Companion_3() {
  }
  protoOf(Companion_3).gsn = function (name) {
    switch (name) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        return Charsets_getInstance().psm_1;
    }
    var tmp;
    var tmp_0;
    switch (name) {
      case 'ISO-8859-1':
      case 'iso-8859-1':
        tmp_0 = true;
        break;
      default:
        // Inline function 'kotlin.let' call

        var it = replace_0(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
        var tmp_1;
        if (it === 'iso-8859-1') {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_1 = it.toLowerCase() === 'iso-8859-1';
        }

        tmp_0 = tmp_1;
        break;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = name === 'latin1' || name === 'Latin1';
    }
    if (tmp) {
      return Charsets_getInstance().qsm_1;
    }
    throw IllegalArgumentException_init_$Create$('Charset ' + name + ' is not supported');
  };
  var Companion_instance_4;
  function Companion_getInstance_3() {
    return Companion_instance_4;
  }
  function Charset(_name) {
    this.rsm_1 = _name;
  }
  protoOf(Charset).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !(this.constructor == other.constructor))
      return false;
    if (!(other instanceof Charset))
      THROW_CCE();
    return this.rsm_1 === other.rsm_1;
  };
  protoOf(Charset).hashCode = function () {
    return getStringHashCode(this.rsm_1);
  };
  protoOf(Charset).toString = function () {
    return this.rsm_1;
  };
  function Charsets() {
    Charsets_instance = this;
    this.psm_1 = new CharsetImpl('UTF-8');
    this.qsm_1 = new CharsetImpl('ISO-8859-1');
  }
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function CharsetDecoder(_charset) {
    this.hsn_1 = _charset;
  }
  function MalformedInputException(message) {
    IOException_init_$Init$_0(message, this);
    captureStack(this, MalformedInputException);
  }
  function get_name(_this__u8e3s4) {
    return _this__u8e3s4.rsm_1;
  }
  function forName(_this__u8e3s4, name) {
    return Companion_instance_4.gsn(name);
  }
  function CharsetEncoder(_charset) {
    this.isn_1 = _charset;
  }
  function decode_0(_this__u8e3s4, input, dst, max) {
    var decoder = Decoder(get_name(get_charset(_this__u8e3s4)), true);
    var tmp0 = input.ls7().n1();
    // Inline function 'kotlin.comparisons.minOf' call
    var b = fromInt(max);
    var count = compare(tmp0, b) <= 0 ? tmp0 : b;
    var array = readByteArray(input, convertToInt(count));
    var tmp;
    try {
      // Inline function 'org.khronos.webgl.toInt8Array' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = decoder.jsn(array);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        var tmp0_elvis_lhs = cause.message;
        throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
      } else {
        throw $p;
      }
    }
    var result = tmp;
    dst.k1(result);
    return result.length;
  }
  function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(fromIndex <= toIndex)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_1(message));
    }
    if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().qsm_1)) {
      return encodeISO88591(input, fromIndex, toIndex, dst);
    }
    // Inline function 'kotlin.require' call
    if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().psm_1)) {
      var message_0 = 'Only UTF-8 encoding is supported in JS';
      throw IllegalArgumentException_init_$Create$(toString_1(message_0));
    }
    var encoder = new TextEncoder();
    // Inline function 'kotlin.text.substring' call
    var tmp$ret$5 = toString_1(charSequenceSubSequence(input, fromIndex, toIndex));
    var result = encoder.encode(tmp$ret$5);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    dst.ws8(result);
    return result.length;
  }
  function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
  }
  function CharsetImpl(name) {
    Charset.call(this, name);
  }
  protoOf(CharsetImpl).tsm = function () {
    return new CharsetEncoderImpl(this);
  };
  protoOf(CharsetImpl).ssm = function () {
    return new CharsetDecoderImpl(this);
  };
  function get_charset(_this__u8e3s4) {
    return _this__u8e3s4.hsn_1;
  }
  function get_charset_0(_this__u8e3s4) {
    return _this__u8e3s4.isn_1;
  }
  function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    var start = fromIndex;
    if (start >= toIndex)
      return new Int8Array(0);
    var dst = new Buffer();
    var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
    start = start + rc | 0;
    if (start === toIndex) {
      return readByteArray_0(dst);
    }
    encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
    return readByteArray_0(dst);
  }
  function CharsetEncoderImpl(charset) {
    CharsetEncoder.call(this, charset);
    this.msn_1 = charset;
  }
  protoOf(CharsetEncoderImpl).toString = function () {
    return 'CharsetEncoderImpl(charset=' + this.msn_1.toString() + ')';
  };
  protoOf(CharsetEncoderImpl).hashCode = function () {
    return this.msn_1.hashCode();
  };
  protoOf(CharsetEncoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetEncoderImpl))
      return false;
    if (!this.msn_1.equals(other.msn_1))
      return false;
    return true;
  };
  function CharsetDecoderImpl(charset) {
    CharsetDecoder.call(this, charset);
    this.osn_1 = charset;
  }
  protoOf(CharsetDecoderImpl).toString = function () {
    return 'CharsetDecoderImpl(charset=' + this.osn_1.toString() + ')';
  };
  protoOf(CharsetDecoderImpl).hashCode = function () {
    return this.osn_1.hashCode();
  };
  protoOf(CharsetDecoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetDecoderImpl))
      return false;
    if (!this.osn_1.equals(other.osn_1))
      return false;
    return true;
  };
  function Decoder(encoding, fatal) {
    fatal = fatal === VOID ? true : fatal;
    var tmp;
    try {
      tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        tmp_0 = new TextDecoderFallback(encoding, fatal);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function toKtor(_this__u8e3s4) {
    return new toKtor$1(_this__u8e3s4);
  }
  function textDecoderOptions(fatal) {
    fatal = fatal === VOID ? false : fatal;
    // Inline function 'kotlin.apply' call
    var this_0 = new Object();
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.with' call
    this_0.fatal = fatal;
    return this_0;
  }
  function toKtor$1($this_toKtor) {
    this.psn_1 = $this_toKtor;
  }
  protoOf(toKtor$1).jsn = function (buffer) {
    return this.psn_1.decode(buffer);
  };
  function get_ENCODING_ALIASES() {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    return ENCODING_ALIASES;
  }
  var ENCODING_ALIASES;
  function get_REPLACEMENT() {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    return REPLACEMENT;
  }
  var REPLACEMENT;
  function TextDecoderFallback(encoding, fatal) {
    this.qsn_1 = fatal;
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var requestedEncoding = toString_1(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.check' call
    if (!get_ENCODING_ALIASES().m1(requestedEncoding)) {
      var message = encoding + ' is not supported.';
      throw IllegalStateException_init_$Create$(toString_1(message));
    }
  }
  protoOf(TextDecoderFallback).jsn = function (buffer) {
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
    var inductionVariable = 0;
    var last = bytes.length;
    if (inductionVariable < last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var byte = bytes[index];
        var point = toCodePoint(byte);
        if (point < 0) {
          // Inline function 'kotlin.check' call
          if (!!this.qsn_1) {
            var message = 'Invalid character: ' + point;
            throw IllegalStateException_init_$Create$(toString_1(message));
          }
          writeFully_0(builder, get_REPLACEMENT());
          continue $l$loop;
        }
        if (point > 255) {
          builder.cs9(toByte(point >> 8));
        }
        builder.cs9(toByte(point & 255));
      }
       while (inductionVariable < last);
    return decodeToString_0(readByteArray_0(builder));
  };
  function toCodePoint(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    var value = _this__u8e3s4 & 255;
    if (isASCII(value)) {
      return value;
    }
    return get_WIN1252_TABLE()[value - 128 | 0];
  }
  function isASCII(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
  }
  var properties_initialized_TextDecoderFallback_js_kt_6rekzk;
  function _init_properties_TextDecoderFallback_js_kt__an7r6m() {
    if (!properties_initialized_TextDecoderFallback_js_kt_6rekzk) {
      properties_initialized_TextDecoderFallback_js_kt_6rekzk = true;
      ENCODING_ALIASES = setOf(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
      // Inline function 'kotlin.byteArrayOf' call
      REPLACEMENT = new Int8Array([-17, -65, -67]);
    }
  }
  function get_DEVELOPMENT_MODE() {
    return false;
  }
  function ioDispatcher() {
    return Dispatchers_getInstance().i1h_1;
  }
  function encodeISO88591(input, fromIndex, toIndex, dst) {
    if (fromIndex >= toIndex)
      return 0;
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(input, index);
        var character = Char__toInt_impl_vasixd(this_0);
        if (character > 255) {
          failedToMapError(character);
        }
        dst.cs9(toByte(character));
      }
       while (inductionVariable < toIndex);
    return toIndex - fromIndex | 0;
  }
  function failedToMapError(ch) {
    throw new MalformedInputException('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
  }
  function get_WIN1252_TABLE() {
    _init_properties_Win1252Table_kt__tl0v64();
    return WIN1252_TABLE;
  }
  var WIN1252_TABLE;
  var properties_initialized_Win1252Table_kt_pkmjoq;
  function _init_properties_Win1252Table_kt__tl0v64() {
    if (!properties_initialized_Win1252Table_kt_pkmjoq) {
      properties_initialized_Win1252Table_kt_pkmjoq = true;
      // Inline function 'kotlin.intArrayOf' call
      WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
    }
  }
  function DefaultPool(capacity) {
    this.ysm_1 = capacity;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.ysm_1;
    tmp.zsm_1 = Array(size);
    this.asn_1 = 0;
  }
  protoOf(DefaultPool).bsn = function (instance) {
  };
  protoOf(DefaultPool).csn = function (instance) {
    return instance;
  };
  protoOf(DefaultPool).dsn = function (instance) {
  };
  protoOf(DefaultPool).esn = function () {
    if (this.asn_1 === 0)
      return this.xsm();
    this.asn_1 = this.asn_1 - 1 | 0;
    var idx = this.asn_1;
    var tmp = this.zsm_1[idx];
    var instance = !(tmp == null) ? tmp : THROW_CCE();
    this.zsm_1[idx] = null;
    return this.csn(instance);
  };
  protoOf(DefaultPool).fsn = function (instance) {
    this.dsn(instance);
    if (this.asn_1 === this.ysm_1) {
      this.bsn(instance);
    } else {
      var _unary__edvuaz = this.asn_1;
      this.asn_1 = _unary__edvuaz + 1 | 0;
      this.zsm_1[_unary__edvuaz] = instance;
    }
  };
  protoOf(DefaultPool).s1d = function () {
    var inductionVariable = 0;
    var last = this.asn_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.zsm_1[i];
        var instance = !(tmp == null) ? tmp : THROW_CCE();
        this.zsm_1[i] = null;
        this.bsn(instance);
      }
       while (inductionVariable < last);
    this.asn_1 = 0;
  };
  //region block: post-declaration
  protoOf(Read).c3y = resume;
  protoOf(Read).nsa = resume_0;
  protoOf(Write).c3y = resume;
  protoOf(Write).nsa = resume_0;
  protoOf(ByteChannel).ssc = awaitContent$default;
  protoOf(ByteReadChannel$Companion$Empty$1).ssc = awaitContent$default;
  protoOf(CountedByteReadChannel).ssc = awaitContent$default;
  protoOf(SourceByteReadChannel).ssc = awaitContent$default;
  protoOf(DefaultPool).j4 = close;
  protoOf(NoPoolImpl).j4 = close;
  //endregion
  //region block: init
  Empty_instance = new Empty();
  Companion_instance_2 = new Companion_1();
  Companion_instance_4 = new Companion_3();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = LineEndingMode__plus_impl_ttpz2j;
  _.$_$.b = Charsets_getInstance;
  _.$_$.c = Companion_getInstance_0;
  _.$_$.d = Companion_getInstance_2;
  _.$_$.e = LineEnding_Lenient_getInstance;
  _.$_$.f = copyTo;
  _.$_$.g = readAvailable;
  _.$_$.h = readLineStrictTo;
  _.$_$.i = readLine;
  _.$_$.j = readPacket;
  _.$_$.k = readRemaining_0;
  _.$_$.l = readRemaining;
  _.$_$.m = readUntil;
  _.$_$.n = skipIfFound;
  _.$_$.o = toByteArray;
  _.$_$.p = writeFully;
  _.$_$.q = MalformedInputException;
  _.$_$.r = decode;
  _.$_$.s = encode;
  _.$_$.t = forName;
  _.$_$.u = get_name;
  _.$_$.v = BytePacketBuilder;
  _.$_$.w = build;
  _.$_$.x = canRead;
  _.$_$.y = discard_0;
  _.$_$.z = readText_0;
  _.$_$.a1 = get_remaining;
  _.$_$.b1 = get_size;
  _.$_$.c1 = takeWhile;
  _.$_$.d1 = toByteArray_0;
  _.$_$.e1 = writeFully_0;
  _.$_$.f1 = writeText;
  _.$_$.g1 = get_ByteArrayPool;
  _.$_$.h1 = DefaultPool;
  _.$_$.i1 = NoPoolImpl;
  _.$_$.j1 = ByteChannel;
  _.$_$.k1 = ByteReadChannel_0;
  _.$_$.l1 = ByteReadChannel;
  _.$_$.m1 = ByteReadChannel_1;
  _.$_$.n1 = ClosedByteChannelException;
  _.$_$.o1 = WriterScope;
  _.$_$.p1 = attachWriterJob;
  _.$_$.q1 = cancel_0;
  _.$_$.r1 = close_0;
  _.$_$.s1 = counted;
  _.$_$.t1 = invokeOnCompletion;
  _.$_$.u1 = ioDispatcher;
  _.$_$.v1 = readText;
  _.$_$.w1 = rethrowCloseCauseIfNeeded;
  _.$_$.x1 = writer;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-io.js.map
